// extracted by mini-css-extract-plugin
export default {"items":"dOUE2eMPosrSOy6rke5H","item":"Q3Wq3OtrnRz4GOrEIy5i","placeHolderShimmer":"QY9XORCm0uf_i9rB8Nta"};